/**
 * Detects a failed lazy-chunk / dynamic-import load.
 *
 * This is the signature of version skew: a tab still running an old build asks for a
 * hashed chunk (e.g. `chunk-AB12CD34.js`) that the latest deploy no longer serves. The
 * cure is a full page reload, not an error report, so every place that reacts to it
 * must recognise all browser wordings. WebKit's wording matters most: every iOS browser
 * (Safari, Chrome "CriOS", Edge, Firefox on iPhone) is WebKit underneath.
 */
const CHUNK_LOAD_MESSAGES = [
  'Failed to fetch dynamically imported module',   // Chromium
  'error loading dynamically imported module',     // Firefox
  'Importing a module script failed',              // WebKit (Safari, all iOS browsers)
  'ChunkLoadError',                                // webpack-style name
  'Loading chunk',                                 // webpack-style message
];

export function isChunkLoadError(error: unknown): boolean {
  if (error === null || error === undefined) {
    return false;
  }
  const raw = error as { message?: unknown; name?: unknown; stack?: unknown };
  const message = String(raw.message ?? error);
  const name = String(raw.name ?? '');
  const stack = String(raw.stack ?? '');

  if (CHUNK_LOAD_MESSAGES.some(m => message.includes(m) || name.includes(m))) {
    return true;
  }
  // Generic network failure raised while fetching a chunk file.
  return message.includes('Failed to fetch') && stack.includes('chunk-');
}
